<template>
    <form ref="form">
        <b-form-group>
            <b-row>
                <b-col sm="4"> <label for="accountNo"> Bölge No </label> </b-col>
                <b-col sm="8"> <b-form-input id="accountNo" v-model="accountNo" placeholder="Bölge No Giriniz" /></b-col>
            </b-row>
            <b-row>
                <b-col sm="4"> <label for="accountNo"> Sinyal </label> </b-col>
                <b-col sm="8"> <b-form-input id="accountNo" v-model="accountNo" placeholder="Bölge No Giriniz" /></b-col>
            </b-row>
            <b-row>
                <b-col sm="4"> <label for="accountNo"> Sorumlu</label> </b-col>
                <b-col sm="8"> <b-form-input id="accountNo" v-model="accountNo" placeholder="Bölge No Giriniz" /></b-col>
            </b-row>
        </b-form-group>
    </form>
</template>

<script>
    export default {
        name: "SubEventForm",
        
    }
</script>


// WEBPACK FOOTER //
// src/pages/General/Defination/modals/SubEventForm.vue